import React from 'react';

import SignUp from '../../components/sign-up/SignUp';

const SignUpPage = () => (
    <div className='signup-page'>
        <SignUp />
    </div>
)

export default SignUpPage;